import { createSlice } from "@reduxjs/toolkit";
import _dropRight from 'lodash/dropRight';
import _find from 'lodash/find';
import _map from 'lodash/map';
import _unionBy from 'lodash/unionBy';
import { 
  getVoiceAnalyses, 
  getVoiceAnalysis,
  clearLocalVoiceAnalyses,
  clearLocalActiveVoiceAnalysis
} from "./actions";

export const initialState = {
  all: { 
    data: [], 
    pagination: { limit: 25, offset: 0, count: 0, total_count: 0 } 
  },
  voiceAnalysis: { 
    id: '', 
    input: '', 
    result: '', 
    voice: null, 
    status: '', 
    updated_at: '' 
  },
  loading: { 
    all: false, 
    voiceAnalysis: false 
  }
};

const slice = createSlice({
  name: 'voiceAnalyses',
  initialState,
  extraReducers(builder) {
    builder
      .addCase(getVoiceAnalyses.pending, (state) => {
        state.loading.all = true;
      })
      .addCase(getVoiceAnalyses.fulfilled, (state, action) => {
        const { voice_analyses, pagination } = action.payload;
        const newData = _unionBy([...state.all.data, ...voice_analyses], 'id');
        
        state.loading.all = false;
        state.all.data = newData;
        state.all.pagination = pagination;
      })
      .addCase(getVoiceAnalyses.rejected, (state) => {
        state.loading.all = false;
      })
      .addCase(getVoiceAnalysis.pending, (state) => {
        state.loading.voiceAnalysis = true;
      })
      .addCase(getVoiceAnalysis.fulfilled, (state, action) => {
        const { data: { voice_analysis }, cable } = action.payload;
        const foundedVoiceAnalysis = !!_find(state.all.data, (s) => s.id === voice_analysis.id);
        const updatedVoiceAnalysis = { ...state.voiceAnalysis, ...voice_analysis };
        const isPageFull = state.all.pagination.count % state.all.pagination.limit === 0 && state.all.pagination.total_count > 0;
        const oldAllData = isPageFull ? _dropRight(state.all.data) : state.all.data;
        const data = foundedVoiceAnalysis ? _map(state.all.data, (e) => e.id === voice_analysis.id ? { ...e, ...voice_analysis } : e) : [...[voice_analysis], ...oldAllData]; 
        const pagination = foundedVoiceAnalysis ? state.all.pagination : { ...state.all.pagination, count: isPageFull ? state.all.pagination.count : state.all.pagination.count + 1, total_count: state.all.pagination.total_count + 1 };
        
        state.loading.voiceAnalysis = false;
        state.all.data = data; 
        state.all.pagination = pagination;
        if (foundedVoiceAnalysis && !cable) state.voiceAnalysis = updatedVoiceAnalysis;       
      })
      .addCase(getVoiceAnalysis.rejected, (state) => {
        state.loading.voiceAnalysis = false;
      })
      .addCase(clearLocalVoiceAnalyses, state => {
        state.all = initialState.all;
      })
      .addCase(clearLocalActiveVoiceAnalysis, state => {
        state.voiceAnalysis = initialState.voiceAnalysis;
      })
  }
})

export default slice.reducer;